import React from 'react';
import css from './BookingTimeFormField.module.css';
import FieldDateAndTimeInput from '../../../../components/OrderPanel/BookingTimeForm/FieldDateAndTimeInput';
import { useIntl } from 'react-intl';
import { useForm, useFormState } from 'react-final-form';
import { useConfiguration } from '../../../../context/configurationContext';
import { fetchTimeSlots, monthlyTimeSlotsSelector } from '../../ServiceOfferingsPage.duck';
import { useDispatch, useSelector } from 'react-redux';
import { dateFormattingOptions } from '../../../../util/enums';

// Helper: Check if monthlyTimeSlots has any actual time slots
const hasAvailableTimeSlots = monthlyTimeSlots => {
  if (!monthlyTimeSlots || typeof monthlyTimeSlots !== 'object') return false;

  return Object.values(monthlyTimeSlots).some(month => {
    const { timeSlots = [], fetchTimeSlotsInProgress, fetchTimeSlotsError } = month || {};
    return (
      !fetchTimeSlotsInProgress &&
      !fetchTimeSlotsError &&
      Array.isArray(timeSlots) &&
      timeSlots.length > 0
    );
  });
};

const BookingTimeFormField = ({ listing }) => {
  const { pristine, values } = useFormState();
  const form = useForm();
  const intl = useIntl();
  const config = useConfiguration();
  const dispatch = useDispatch();

  const monthlyTimeSlots = useSelector(monthlyTimeSlotsSelector);
  const timeZone = listing?.attributes?.availabilityPlan?.timezone;
  const listingId = listing?.id?.uuid;

  const TODAY = new Date();
  const startDatePlaceholder = intl.formatDate(TODAY, dateFormattingOptions);
  const endDatePlaceholder = intl.formatDate(TODAY, dateFormattingOptions);

  // Critical: Return null if no time slots exist (even if object exists)
  if (!listingId || !timeZone || !hasAvailableTimeSlots(monthlyTimeSlots)) {
    return null;
  }

  return (
    <div className={css.bookingTimeField}>
      <FieldDateAndTimeInput
        startDateInputProps={{
          label: intl.formatMessage({ id: 'BookingTimeForm.bookingStartTitle' }),
          placeholderText: startDatePlaceholder,
        }}
        endDateInputProps={{
          label: intl.formatMessage({ id: 'BookingTimeForm.bookingEndTitle' }),
          placeholderText: endDatePlaceholder,
        }}
        className={css.bookingDates}
        listingId={listingId}
        onFetchTimeSlots={(listingId, start, end, timeZone) =>
          dispatch(fetchTimeSlots(listingId, start, end, timeZone))
        }
        monthlyTimeSlots={monthlyTimeSlots}
        values={values}
        intl={intl}
        form={form}
        pristine={pristine}
        timeZone={timeZone}
        dayCountAvailableForBooking={config.stripe.dayCountAvailableForBooking}
      />
    </div>
  );
};

export default BookingTimeFormField;
